/** Single-store site: ships from one store (e.g. 91), set via env. */
export const defaultStoreNumber = Number(process.env.NEXT_PUBLIC_DEFAULT_STORE_ID) || 91;
